import { render, staticRenderFns } from "./SideBarRight.vue?vue&type=template&id=4a430acc&scoped=true"
import script from "./SideBarRight.vue?vue&type=script&lang=js"
export * from "./SideBarRight.vue?vue&type=script&lang=js"
import style0 from "./SideBarRight.vue?vue&type=style&index=0&id=4a430acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a430acc",
  null
  
)

export default component.exports